import React, { Component } from 'react'
import '../Common.scss';
import defaultImage from '../../../assets/default.png';

export default class CrossSection extends Component<any,any> {
  render() {
    const { pageDetails } = this.props;
    const { elevationImage,visualizerMetaData} = pageDetails;
    return (
     <React.Fragment>
          <div className="page-image-container">
                    <div className="page-heading">{pageDetails?.name}</div>
                    <div className="image-section-container-crosssection">
                        <img crossOrigin="anonymous" src={elevationImage?.imageUrl ? `${elevationImage?.imageUrl}` :defaultImage} alt="" className="image-view" />
                    </div>
            </div>
            <div className="details-tables">
                    <div className="table-header">
                        <div className="details-heading-wrapper details-heading">
                            CROSS SECTION SPECIFICATIONS
                        </div>
                        {
                  
                                    <React.Fragment>
                                        <div className="details-table">
                                            <React.Fragment>
                                                {
                                                    visualizerMetaData && Object.entries(visualizerMetaData)?.map((property,index)=> {
                                                            return (
                                                                    <React.Fragment key={index}>
                                                                        {
                                                                            <div className="table-row">
                                                                            <div className="table-cell">
                                                                                    {property[0]}
                                                                            </div>
                                                                            <div className="table-cell">
                                                                                    {property[1]}
                                                                            </div>
                                                                            </div>
                                                                        }
                                                                    </React.Fragment>
                                                                    )
                                                                })
                                                    }
                                            </React.Fragment>
                                            </div>
                                        </React.Fragment>
                            }
                            

                        </div>
                    </div>

     </React.Fragment>
    )
  }
}